import styled from 'styled-components'

export const RelacionadasContainer = styled('div')`
  margin: 0;
  background-color: white;
  padding: 24px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey8};
`

export const SectionTitle = styled('p')`
  color: ${({ theme }) => theme.colors.grey100};
  font-size: 16px;
`

export const LinksContainer = styled('ul')`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    flex-direction: row;
    flex-flow: wrap;
  }
`

export const Li = styled('li')`
  width: 100%;
  float: left;
  list-style: none;
  margin-top: 12px;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    width: 50%;
    margin-top: 0;
  }
`

export const Link = styled('a')`
  color: #585992;
  text-decoration: none !important;
`

export const LinkTitle = styled('h3')`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.grey72};
  font-weight: 400;
  line-height: 30px;

  &:hover {
    color: ${({ theme }) => theme.colors.grey84};
  }
`
